import { ISeparators } from './types';

export enum MERCHANT_TERMINAL_KEYS {
  GOOGLE_FONTS = 'googleFonts',
  MERCHANT_TERMINAL_THEMES = 'merchantThemes',
}

export const MAX_THEMES_COUNT = 20;

export const FALLBACK_SEPARATOR_NAMES: ISeparators = {
  decimalSeparator: 'DOT',
  thousandsSeparator: 'NONE',
};
